import React from "react";
import "./App.scss";
import Header from "./components/Header/Header";
import Main from "./components/Main/Main";
import Footer from "./components/Footer/Footer";
import {ModalProvider} from "./context/ModalContext";
import {ResponseStatusProvider} from "./context/ResponseStatusContext";
import { Helmet } from "react-helmet-async";

function App() {
    return (
        <div className="App">
            <Helmet>
                <title>ELS GROUP — пространство, где инновации обретают форму</title>
                <meta name="description" content="ELS GROUP — экосистема, объединяющая технологии и многолетний опыт для создания уникальных решений в области повышения качества жизни клиентов ⭐️ Более 6,5млн+ клиентов ⭐️ Более 150+ корпоративных партнёров ⭐️ На рынке с 2007 года" />
                <meta property="og:title" content="ELS GROUP — пространство, где инновации обретают форму" />
                <meta property="og:description" content="ELS GROUP — экосистема, объединяющая технологии и многолетний опыт для создания уникальных решений в области повышения качества жизни клиентов ⭐️ Более 6,5млн+ клиентов ⭐️ Более 150+ корпоративных партнёров ⭐️ На рынке с 2007 года" />
                <meta property="og:image" content="https://elsgroup.ru/assets/image/preloadDesktop.png" />
                <meta property="og:url" content="https://elsgroup.ru" />
                <meta property="og:type" content="website" />
            </Helmet>
            <ModalProvider>
                <ResponseStatusProvider>
                    <Header/>
                    <Main/>
                    <Footer id='contacts'/>
                </ResponseStatusProvider>
            </ModalProvider>
        </div>
    );
}

export default App;
